(function ($, document, window) {
    'use strict';

    $(function () {
        const swiper = new Swiper('.js-featured-posts', {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 30,
            mobileFirst: true,
            grabCursor: true,
            speed: 800,

            pagination: {
                el: '.js-featured-posts-pagination',
                type: 'progressbar',
            },

            navigation: {
                prevEl: '.js-featured-posts-nav-prev',
                nextEl: '.js-featured-posts-nav-next',
            },

            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },

                1024: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
        });
    });
})(jQuery, document, window);
